import React, { useEffect } from 'react';
export function RobotsTxt() {
  const content = `User-agent: *
Allow: /

Sitemap: https://viridiaanalytics.com/sitemap.xml`;
  useEffect(() => {
    // Replace entire document with raw text for crawler compatibility
    document.title = 'robots.txt';
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.remove();
  }, []);
  return <pre style={{
    position: 'fixed',
    inset: 0,
    zIndex: 99999,
    background: 'white',
    color: 'black',
    padding: '1rem',
    margin: 0,
    fontFamily: 'monospace',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5
  }} data-id="element-1941">
      {content}
    </pre>;
}